export default {
  slug: 'ws-composite-group',
  CONVERT_TO_GROUP_TRIGGER_ID: 'convert-to-composite-image-widget',
  DEFAULT_MEDIA_SIZE: 150,
  REORDER_COMPOSITE_WIDGET_TRIGGER_ID: 'reorder-composite-widget',
  MOVE_FORWARD: 'move-forward',
  MOVE_BACKWARD: 'move-backward',
  SELECT_LAYER: 'select-layer',
  COMPOSITE_WIDGET_DUPLICATED_TRIGGER_ID: 'composite-widget-duplicated',
  DATA_CREATION_SEQUENCE_ATTRIBUTE: 'data-creation-sequence',
  CREATE_LAYOUT_TRIGGER_ID: 'create-layout',
};
